import { render } from "./WEditor.vue?vue&type=template&id=89f3920c"
import script from "./WEditor.vue?vue&type=script&lang=js"
export * from "./WEditor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Vue\\frame2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__